import { Form } from 'react-bootstrap';
import { LockIcon } from './icons';

function ReadOnlyField({ label, controlId, children }) {
  return (
    <Form.Group className="mb-3 im-readonly-field" controlId={controlId}>
      <Form.Label className="d-flex align-items-center gap-1">
        <LockIcon />
        {label}
      </Form.Label>
      {children}
      <Form.Text className="text-muted">
        Definido en IM, no se edita desde acá
      </Form.Text>
    </Form.Group>
  );
}

export default ReadOnlyField;
